import { useFeatureEntitlements } from '@frontegg/react';
import { AmbientAiIcon, TemplateStudioMenuIcon, MemoryIcon } from 'src/icons';
import { ProIcon } from 'src/icons/Pro.icon';
import { LockIcon } from 'src/icons/Lock.icon';
import { AutotemplateMenuIcon } from 'src/icons';
import { UpgradeTooltip } from './components/Payments/UpgradeTooltip';
import { useIsOP } from 'src/hooks/misc';
import Integration from 'src/icons/Integration';

const getAutoTemplateMenuItem = (hasAutoTemplateAccess) => {
  if (hasAutoTemplateAccess) {
    return {
      path: '/autotemplate',
      title: <span className="flex items-center">Auto Template</span>,
      icon: <AutotemplateMenuIcon />,
    };
  }
  return {
    path: '/autotemplate',
    title: (
      <UpgradeTooltip>
        <span className="flex items-center gap-2">
          Auto Template
          <LockIcon />
        </span>
      </UpgradeTooltip>
    ),
    icon: <AutotemplateMenuIcon />,
  };
};

export const useAmbientSoloSideMenus = ({ activeMenu }) => {
  const { isEntitled: hasAmbientAccess } = useFeatureEntitlements('ambient');
  const { isEntitled: hasIntakeAccess } = useFeatureEntitlements('intake');
  const { isEntitled: hasFollowupAccess } = useFeatureEntitlements('followup');
  const { isEntitled: hasMemoryAccess } = useFeatureEntitlements('memory');
  const { isEntitled: hasAutoTemplateAccess } =
    useFeatureEntitlements('auto-template');
  const { isEntitled: zoomEncountersAccess } =
    useFeatureEntitlements('zoom-encounters');
  const hasVCAAccess = hasIntakeAccess || hasFollowupAccess;
  const isOP = useIsOP();

  const menus = [];

  if (!hasAmbientAccess) {
    return [];
  }

  const encountersMenuItem = {
    path: '/encounters',
    title: `${isOP ? 'Opie' : 'Aura'} AI Scribe`,
    icon: <AmbientAiIcon isFilled={activeMenu === 'Aura AI Scribe'} />,
  };
  const submenuItems = [];

  if (hasVCAAccess) {
    if (hasMemoryAccess) {
      submenuItems.push({
        path: '/memory',
        title: 'Memory',
        icon: <MemoryIcon isFilled={activeMenu === 'Memory'} />,
      });
    }
  } else {
    if (hasMemoryAccess) {
      menus.push({
        path: '/memory',
        title: (
          <span className="flex items-center gap-2">
            Memory
            <ProIcon />
          </span>
        ),
        icon: <MemoryIcon />,
      });
    } else {
      menus.push({
        path: '/memory',
        title: (
          <UpgradeTooltip>
            <span className="flex items-center gap-2">
              Memory
              <LockIcon />
            </span>
          </UpgradeTooltip>
        ),
        icon: <MemoryIcon />,
      });
    }
  }

  if (submenuItems.length > 0 || hasVCAAccess) {
    encountersMenuItem.submenu = submenuItems;
  }

  menus.push(encountersMenuItem);

  if (!isOP) {
    menus.push(getAutoTemplateMenuItem(hasAutoTemplateAccess));
  }

  menus.push({
    path: '/setting',
    title: 'Template Studio',
    icon: (
      <TemplateStudioMenuIcon isFilled={activeMenu === 'Template Studio'} />
    ),
  });

  if (zoomEncountersAccess) {
    menus.push({
      path: '/integrations',
      title: 'Integrations',
      icon: <Integration isFilled={activeMenu === 'Integrations'} />,
    });
  }

  return menus;
};
